const shouldShowGlobalBanner = (pageOptions, currentPageURL) => {
    // ToDo: Find a better way to handle this.. too hardcoded and hacky
    if (currentPageURL?.includes("patio/")) return false;
    if (currentPageURL?.includes("grill-and-heating/")) return false;

    if (pageOptions?.length === 0) return false;
    return pageOptions?.some((pageOption) => currentPageURL?.includes(pageOption));
};

export default shouldShowGlobalBanner;
